import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import './Button.css';
import { IButton } from '../../types/IButton';

/**
 * Storybook - Button Component
 * @param ariaLabel
 * @param icon
 * @param isLoading
 * @param isDisbaled
 * @param label
 * @param variant - mandatory
 * @param onClick
 * @param className
 * @param title
 * @returns Button component
 */
const Buttons: React.FC<IButton> = ({
  ariaLabel,
  icon = '',
  isLoading = false,
  isDisabled = false,
  label,
  variant,
  className,
  onClick,
  title,
}) => {
  const buttonRef = useRef<HTMLAnchorElement>(null);

  const showIcon = () =>
    variant === 'icon-button' ? (
      <i
        aria-label={ariaLabel}
        data-testid="button-with-icon"
        className={`${icon} icon-cls`}
      ></i>
    ) : (
      <FontAwesomeIcon
        aria-label={ariaLabel}
        className={isLoading ? 'icon-spinner' : undefined}
        icon={icon}
      />
    );

  const handleOnKeyUp = (event: { key: string }) => {
    {
      (event.key === 'Enter' || event.key === ' ') &&
        (!isLoading || !isDisabled) &&
        onClick &&
        onClick();
    }
    if (buttonRef.current?.className.match('outline-primary')) {
      buttonRef.current?.classList.remove('outline-primary-active');
    } else if (buttonRef.current?.className.match('secondary')) {
      buttonRef.current?.classList.remove('secondary-active');
    } else if (buttonRef.current?.className.match('primary')) {
      buttonRef.current?.classList.remove('primary-active');
    } else if (buttonRef.current?.className.match('icon-button')) {
      buttonRef.current?.classList.remove('active-cls');
    }
  };

  const handleOnKeyDown = (event: { key: string }) => {
    if (
      (event.key === 'Enter' || event.key === ' ') &&
      (!isLoading || !isDisabled)
    ) {
      if (buttonRef.current?.className.match('outline-primary')) {
        buttonRef.current?.classList.add('outline-primary-active');
      } else if (buttonRef.current?.className.match('secondary')) {
        buttonRef.current?.classList.add('secondary-active');
      } else if (buttonRef.current?.className.match('primary')) {
        buttonRef.current?.classList.add('primary-active');
      } else if (buttonRef.current?.className.match('link-button')) {
        buttonRef.current?.classList.add('link-button');
      } else if (buttonRef.current?.className.match('icon-button')) {
        buttonRef.current?.classList.add('active-cls');
      }
    }
  };

  return (
    <a
      data-testid="button-element"
      role="button"
      type="button"
      className={
        'button-wrapper ' +
        `${className} ` +
        (isDisabled ? variant + ' disabled' : variant)
      }
      title={title}
      aria-label={ariaLabel}
      tabIndex={0}
      onClick={!isLoading && !isDisabled ? onClick : undefined}
      onKeyDown={!isLoading && !isDisabled ? handleOnKeyDown : undefined}
      onKeyUp={!isLoading && !isDisabled ? handleOnKeyUp : undefined}
      ref={buttonRef}
      style={isLoading ? { pointerEvents: 'none' } : undefined}
    >
      {label}
      {icon ? showIcon() : null}
    </a>
  );
};
export default Buttons;
